/**
 * What a failed POST /api/auth/sso/register means for the user. Only an upstream fault is
 * worth resubmitting: the Academy API writes the rotated refresh token before anything that
 * can 5xx, and the BFF relays it, so the retry carries a live token. Every 4xx is final —
 * a rejected rotation (the token is spent), the admin gate, or a duplicate email — and
 * resubmitting just repeats it, so the user has to start the SSO sign-in again.
 */
export type SsoRegistrationFailure =
  | { retryable: true; notice: string }
  | { retryable: false; message: string };

const FINAL_MESSAGES: Record<number, string> = {
  403: 'Access denied. Please contact support.',
  409: 'An Academy account already uses this email. Please sign in with your email and password.',
};

const EXPIRED_MESSAGE =
  'Your sign-in could not be completed. Please sign in with Contentstack again.';

export function classifySsoRegistrationFailure(status: number): SsoRegistrationFailure {
  if (status >= 500) {
    return { retryable: true, notice: "Contentstack didn't respond. Please try again." };
  }
  return { retryable: false, message: FINAL_MESSAGES[status] ?? EXPIRED_MESSAGE };
}
